import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { RiRadioButtonFill } from "react-icons/ri";

import { AppContext } from "../Context";
import Popups from "../components/Pop";
import Fetch, { Loader } from "../inc/Fetch";
import './css/SelectSchool.css'

export default function Send() {
    
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();


    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [loading, setloading] = useState(false);

    function submit(school){ 
        setloading(true);
        
        Fetch("user/selectSchool", (r) => {
            
            console.log(r);
            
            if (r?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[r?.error] });
            } else {
                setopen({ error:false, short: t("success_school_change") });
                navigate(-1)
            }

            setloading(false);
        }, school);
      
    }



    return (
        <>
            {loading && <Loader />}
            <Popups style={{maxWidth:350,}}>
                <h1>{t("header_user_menu_4")}</h1>

                <div className='popupBody schoolsChangeListBox' style={{padding:20}}>
                    {userinfo?.school_id?.map((v, k) => {
                        return (
                            <a onClick={() => submit(v)} key={k}>
                                <RiRadioButtonFill />
                                <span>{v?.name}</span>
                            </a>
                        );
                    })}
                    
                </div>


            </Popups>
        </>
    )
}
